import { combineReducers } from 'redux';

import {
  setOpenWebPageInstructionModal,
  setWebPageInstructionId,
  setInlineWebPageInstruction,
} from '../actions';
import { ScriptEditorAction, WebPageInstructionState } from '../types';
import { Reducer } from '../../../types';

type ReducerOf<T extends keyof WebPageInstructionState> = Reducer<WebPageInstructionState, ScriptEditorAction, T>;

const isOpenModal: ReducerOf<'isOpenModal'> = (state = false, action) => {
  switch (action.type) {
    case setOpenWebPageInstructionModal.type:
      return action.payload;

    default:
      return state;
  }
};

const instructionId: ReducerOf<'instructionId'> = (state = '', action) => {
  switch (action.type) {
    case setWebPageInstructionId.type:
      return action.payload;

    default:
      return state;
  }
};

const isInline: ReducerOf<'isInline'> = (state = true, action) => {
  switch (action.type) {
    case setInlineWebPageInstruction.type:
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers({
  isOpenModal,
  isInline,
  instructionId,
});
